// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1dsPo","label":"Category_label__2kqpF","content":"Category_content__3TIa4","header":"Category_header__4wOFw","location":"Category_location__3E7vf"};